import type { BudgetComment } from '../types'
import { CommentsMap, getCellKeyFromComment } from '../utils/commentUtils'

/**
 * Convert comments array to map indexed by cell key
 */
export const commentsToMap = (comments: BudgetComment[]): CommentsMap => {
  const map: CommentsMap = new Map()

  comments.forEach(comment => {
    const cellKey = getCellKeyFromComment(comment)
    if (!cellKey) return

    if (!map.has(cellKey)) {
      map.set(cellKey, [])
    }
    map.get(cellKey)!.push(comment)
  })

  return map
}
